import styles from './InitialPageL1.module.css'
import DistrictInfo from './general/DistrictInfo'
import StackedBarGraph from '../../../general/StackedBarGraph'
import Api from '../../../../services/Api'
import React, { useEffect, useState } from "react";

function InitialPageL1({distrito, onDistrictMapChange, setProdAgropecImage, setMapImage}) {
    const [contProdAgropec, setcontProdAgropec] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Api.getImoveisPorProdAgropec(distrito).then((value) => {
            setcontProdAgropec(value);
            setLoading(false);
        });
    }, [distrito]);

    return (
        <div className={styles.initialPageL1}>
            <DistrictInfo distrito={distrito} onDistrictMapChange={onDistrictMapChange} setMapImage={setMapImage} />
            <div className={styles.barGraph}>
                {loading && <p>Carregando gráfico...</p>}

                {!loading && contProdAgropec && (
                    <div className={styles.graph} >
                        <StackedBarGraph data={contProdAgropec} isProdAgropec={true} onImageReady={setProdAgropecImage} text="NÚMERO DE IMÓVEIS POR PRODUÇÃO AGROPECUÁRIA" />
                    </div>
                )}

                {!loading && !contProdAgropec && (
                    <p style={{ color: 'red' }}>Erro ao carregar dados do gráfico.</p>
                )}
            </div>
        </div>
    )
}

export default InitialPageL1